import { baseUrl, headers, jwtHeaders, logoutUtil } from "../common/data";

export const fetchAllAppointments = async () => {
    const response = await fetch(`${baseUrl}/api/appointment/getallappointments`, {
        method: "GET",
        headers: headers,
        redirect: "follow",
    });
    const resData = await response?.json();
   
    return resData;
};

export const createAppointment = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/appointment/create`, {
            method: 'POST',
            body: data,
            headers: headers
        })
        const resData = await response?.json();
       
        return resData;
    } catch (err) { }
};

export const deleteAppointment = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/membership/deletemembership/${data}`, {
            method: 'DELETE',
            headers: headers,
        })
        const resData = await response?.json();
       
        return resData;
    } catch (err) { }
};


// export const editInfo = async (data, id) => {
//     try {
//         const response = await fetch(`${baseUrl}/api/content/update/${id}`, {
//             method: 'PUT',
//             body: JSON.stringify(data),
//             headers: jwtHeaders()
//         })
//         const resData = await response?.json();
//        
//         return resData;
//     } catch (err) { }
// };

